import { provideWidgetClass } from "scrivito"

export const MarkdownWidget = provideWidgetClass("MarkdownWidget", {
  attributes: {
    text: "string"
  },
  extractTextAttributes: ["text"]
})
